import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "buttons" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_4 = { class: "note" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Notes", -1)
const _hoisted_6 = { class: "col half note-list" }

import { computed, markRaw, onMounted } from "vue";
import { useStore } from "vuex";
import { Note } from "@/models/note";
import { Actions } from "@/store";
import { useRouter } from "vue-router";
import NoteCard from "./NoteCard.vue";
import Filter from "@/components/common/Filter.vue";
import { DrawerMutations } from "@/stores/drawer.store";
import ShortcutForm from "../shortcut/ShortcutForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Notes',
  setup(__props) {

const store = useStore();
const router = useRouter();
const notes = computed<Note[]>(() =>
  [...store.getters.filteredNotes].sort((a, b) => (a.title > b.title ? 1 : -1))
);

onMounted(() => {
  store.dispatch(Actions.GetNotes);
});

const addNote = () => {
  store.dispatch(Actions.NewNote);
  router.push("/note/add");
};

const addShortcut = () => {
  store.dispatch(Actions.NewShortcut);
  store.commit(DrawerMutations.OpenDrawer, {
    drawer: markRaw(ShortcutForm),
    data: {
      drawer: true
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Filter),
      _createElementVNode("button", {
        type: "button",
        class: "option",
        onClick: addShortcut
      }, [
        _hoisted_2,
        _createTextVNode(" Add Shortcut ")
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "option",
        onClick: addNote
      }, [
        _hoisted_3,
        _createTextVNode(" Add Note ")
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, (note) => {
          return (_openBlock(), _createBlock(NoteCard, { note: note }, null, 8, ["note"]))
        }), 256))
      ])
    ])
  ], 64))
}
}

})